export default "__VITE_ASSET__DxSVnwTk__"